import React from 'react';

import styles from './../../../ricos-common-plugins/gap-spacer/gap-spacer-component/gap-spacer-styles-scss.js';

export const GapSpacer: React.FC = () => {
  return <div className={styles.gapSpacerViewer} />;
};
